<template>
    <div class="col-md-12 panel">
        <tabs>
            <tab title="По инструктору">
                <loading :active.sync="byTrainer.isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-heading">
                                <div class="panel-title hidden-xs">
                                    <span class="glyphicon glyphicon-tasks"></span>Преподаватели <span
                                        id="instructor_name"></span></div>
                            </div>
                            <form v-on:submit.prevent="getByTrainer" class="ng-pristine ng-valid">
                                <div class="panel-body ">
                                    <div class="col-md-4">
                                        <select v-model="byTrainer.trainerId" class="form-control" required="">
                                            <option v-for="trainer in data.trainers" v-bind:key="trainer.id" :value="trainer.id">
                                                {{trainer.last_name}}
                                                {{trainer.first_name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="byTrainer.from" class="form-control"
                                               value="" placeholder="Начало периода" required="">
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="byTrainer.to" class="form-control"
                                               value="" placeholder="Конец периода" required="">

                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <button type="submit" class="btn btn-primary getstat"> Показать </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="section row" v-if="byTrainer.rows.length > 0">
                    <div class="col-md-4">
                        <div class="panel panel-tile text-center br-a br-light">
                            <div class="panel-body bg-light dark">
                                <h2 class="mt15 lh15">
                                    <b>
                                        <span id="total" v-if="byTrainer.rows.length > 0">{{byTrainer.sum | numberFormat(0, '.', ' ')}}</span>
                                        <span v-else>---</span>
                                        <i class="fa fa-ruble"></i>
                                    </b>
                                </h2>
                            </div>
                            <div class="panel-footer">
                                <span class="text-muted">
                                    Итого (смены)
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="panel panel-tile text-center br-a br-light">
                            <div class="panel-body bg-light dark">
                                <h2 class="mt15 lh15">
                                    <b>
                                        <span id="total_all" v-if="byTrainer.rows.length > 0">{{byTrainer.sum | numberFormat(0, '.', ' ')}}</span>
                                        <span v-else>---</span>
                                        <i class="fa fa-ruble"></i>
                                    </b>
                                </h2>
                            </div>
                            <div class="panel-footer">
                                <span class="text-muted">
                                    Выплата
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section row" v-if="byTrainer.rows.length > 0">
                    <div class="col-md-12">
                        <div class="panel panel-visible">

                            <div class="panel-body pn">
                                <table class="table table-striped table-hover datatables table-fixed-header" cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th>Дата</th>
                                        <th>Занятие</th>
                                        <th>Инструктор</th>
                                        <th>Посещения</th>
                                        <th>Выплата</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in byTrainer.rows" v-bind:key="index">
                                        <td>{{row.date}}</td>
                                        <td>{{row.event}}</td>
                                        <td>{{row.trainer}}</td>
                                        <td>{{row.visits}}</td>
                                        <td class="sum-cell">{{row.sum | numberFormat(0, '.', ' ')}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab title="По всем инструкторам">
                <loading :active.sync="all.isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-heading">
                                <div class="panel-title hidden-xs">
                                    <span class="glyphicon glyphicon-tasks"></span>Преподаватели <span></span></div>
                            </div>
                            <form v-on:submit.prevent="getAll" class="ng-pristine ng-valid">
                                <div class="panel-body ">
                                    <div class="col-md-4">
                                        <input type="date" v-model="all.from" class="form-control"
                                               value="" placeholder="Начало периода" required="">
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="all.to" class="form-control"
                                               value="" placeholder="Конец периода" required="">

                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <button type="submit" class="btn btn-primary getstat"> Показать </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="section row" v-if="all.rows.length > 0">
                    <div class="col-md-4">
                        <div class="panel panel-tile text-center br-a br-light">
                            <div class="panel-body bg-light dark">
                                <h2 class="mt15 lh15">
                                    <b>
                                        <span v-if="all.rows.length > 0">{{all.sum | numberFormat(0, '.', ' ')}}</span>
                                        <span v-else>---</span>
                                        <i class="fa fa-ruble"></i>
                                    </b>
                                </h2>
                            </div>
                            <div class="panel-footer">
                                <span class="text-muted">
                                    Итого
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section row" v-if="all.rows.length > 0">
                    <div class="col-md-12">
                        <div class="panel panel-visible">

                            <div class="panel-body pn">
                                <table class="table table-striped table-hover datatables table-fixed-header" cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th>Инструктор</th>
                                        <th>Выплата</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in all.rows" v-bind:key="index">
                                        <td>{{row.trainer}}</td>
                                        <td class="sum-cell">{{row.sum | numberFormat(0, '.', ' ')}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
    </div>
</template>

<script>
    import Report from "../../classes/api/Report";
    import {Tabs, Tab} from 'vue-slim-tabs'
    import Trainer from "../../models/v2/Trainer";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            tabs: Tabs,
            tab: Tab,
        },
        async beforeMount() {
            const trainerResponse = await Trainer.getList({}, 1, 'last_name,first_name', -1);

            this.data.trainers = trainerResponse.data;
        },

        data() {
            return {
                data: {
                    trainers: [],
                },
                byTrainer: {
                    isLoading: false,
                    sum: 0,
                    trainerId: 0,
                    from: '',
                    to: '',
                    rows: []
                },
                all: {
                    isLoading: false,
                    from: '',
                    to: '',
                    rows: []
                },
            };
        },
        methods: {
            async getByTrainer() {
                this.byTrainer.isLoading = true;

                let response = await Report.getSalary(this.byTrainer.from, this.byTrainer.to, this.byTrainer.trainerId);
                this.byTrainer.rows = response.data;

                this.byTrainer.sum = 0;
                for (let row of this.byTrainer.rows) {
                    this.byTrainer.sum += row.sum;
                }

                this.byTrainer.isLoading = false;
            },
            async getAll() {
                this.all.isLoading = true;

                let response = await Report.getSalary(this.all.from, this.all.to);
                this.all.rows = response.data;

                this.all.sum = 0;
                for (let row of this.all.rows) {
                    this.all.sum += row.sum;
                }

                this.all.isLoading = false;
            },
        },
        metaInfo() {
            return {
                title: 'Отчеты - выплаты инструкторам',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
